import { useEffect } from 'react';

import { mixpanelObject } from 'src/utils/analytics';
import { clearCtaEventsProperty } from 'src/utils/analytics/mixpanel/mixpanelHelper';
import {
  getLocalStorage,
  setLocalStorage
} from 'src/utils/browserStorageHandler';
import {
  SETTINGS,
  USER_TOKEN,
  USER_TYPE
} from 'src/utils/constants/localStorageConstants';
import {
  DisplayLanguage,
  UserTypes
} from 'src/utils/constants/stringConstants';
import {
  ContentLangugaBannerEnums,
  DEVICE_WIDTH_CONSTANTS
} from 'src/utils/constants/utilConstants';

import { useAppStore } from 'src/hooks/useAppStore';
import {
  getContentLanguageBannerText,
  setRegisteredUserVisibilityCount,
  setGuestUserVisibilityCount,
  viewCountHandler,
  postSettingDataHandler
} from './helpers';
import { Container, CrossButton, Header, TextContainer, Title } from './styles';
import {
  MIXPANEL_ELEMENT,
  MIXPANEL_BUTTON_TYPE,
  MIXPANEL_CTA,
  MIXPANEL_HEADER,
  MIXPANEL_HORIZONTAL_INDEX,
  MIXPANEL_PAGE_NAME,
  MIXPANEL_WIDGET_NAME
} from '../../utils/analytics/mixpanel/mixpanelConstants';
import { getContentLanguageConfig } from '../../services/apiRequests/launchApiHelper';
import {
  contentLanguageBannerEvent,
  ctaEvent
} from '../../utils/analytics/mixpanel/mixpanelEventsHelper';

enum TriggerWidgetType {
  IMPRESSION = 'impression'
}

const triggerLanguagePopupOpenMixpanelEvents = () => {
  const appHeaderIndex = '0';
  clearCtaEventsProperty(mixpanelObject);
  mixpanelObject.setProperty(MIXPANEL_ELEMENT, 'Language');
  mixpanelObject.setProperty(MIXPANEL_BUTTON_TYPE, MIXPANEL_HEADER);
  mixpanelObject.setProperty(MIXPANEL_HORIZONTAL_INDEX, appHeaderIndex);
  //TODO: ADD onboarding stuff
  ctaEvent();
};

const triggerWidgetEvent = (isImpression = '') => {
  mixpanelObject.setProperty(MIXPANEL_WIDGET_NAME, 'Content Language HP');
  mixpanelObject.setProperty(MIXPANEL_PAGE_NAME, 'Home');
  if (isImpression === MIXPANEL_CTA) {
    mixpanelObject.setProperty(MIXPANEL_ELEMENT, 'Close');
    contentLanguageBannerEvent(false);
  } else if (isImpression === 'impression') {
    contentLanguageBannerEvent(true);
  }
};

const LAGNUAGE_BANNER_TIME_OUT = 60000;

const LanguageToolTip = () => {
  const {
    usersPreferenceData,
    initialLaunchData,
    popups,
    setPopups,
    translations,
    appConfig
  } = useAppStore();

  const showPopup =
    popups.showLanguageBanner &&
    appConfig.deviceWidth! > DEVICE_WIDTH_CONSTANTS.deviceWidth1200;

  const userContentLanguages =
    usersPreferenceData?.content_language ||
    getLocalStorage(SETTINGS)?.content_language ||
    '';

  const contentLanguages = getContentLanguageConfig(initialLaunchData);
  const displayLanguage =
    usersPreferenceData?.display_language || DisplayLanguage.ENGLISH;
  const userContentLanguagesArray = userContentLanguages.split(',');

  const {
    SESSION_VALUE_FOR_LOGGED_IN,
    NO_OF_VISIBILITY,
    VISBILITY_COUNT,
    MAX_VISBILITY_COUNT
  } = ContentLangugaBannerEnums;

  const languageBannerText = getContentLanguageBannerText(
    displayLanguage,
    userContentLanguages,
    contentLanguages
  );

  const titleText =
    translations.common.CONTENT_LANGUAGE_BANNER.HomeScreen_ContentLanguageWidget_Body_Text.replace(
      '{{languages}}',
      languageBannerText
    );

  const headerText =
    translations.common.CONTENT_LANGUAGE_BANNER
      .HomeScreen_ContentLanguageWidget_Header_Text;

  const token = getLocalStorage(USER_TOKEN);
  const userType = getLocalStorage(USER_TYPE) || UserTypes.GUEST;

  const handleClose = () => {
    userType === UserTypes.GUEST
      ? setGuestUserVisibilityCount(MAX_VISBILITY_COUNT)
      : setRegisteredUserVisibilityCount(MAX_VISBILITY_COUNT, token);
    triggerWidgetEvent(MIXPANEL_CTA);
    setPopups({ showLanguageBanner: false });
  };

  const handleLanguagePopupClick = () => {
    handleClose();
    triggerLanguagePopupOpenMixpanelEvents();
    setPopups({ showLanguagePopup: true });
  };

  useEffect(() => {
    // intitializing the counts
    const { viewCounts, isPostCalled } = viewCountHandler(userType, token);

    if (viewCounts < NO_OF_VISIBILITY) {
      setPopups({ showLanguageBanner: true });
    }

    if (userContentLanguagesArray.length > MAX_VISBILITY_COUNT) {
      userType === UserTypes.GUEST
        ? setGuestUserVisibilityCount(MAX_VISBILITY_COUNT)
        : setRegisteredUserVisibilityCount(MAX_VISBILITY_COUNT, token);
      setPopups({ showLanguageBanner: false });
      return;
    }

    if (viewCounts === 0 || viewCounts <= NO_OF_VISIBILITY) {
      if (userType === UserTypes.GUEST) {
        setGuestUserVisibilityCount(viewCounts + 1);
      } else {
        postSettingDataHandler(
          isPostCalled,
          viewCounts,
          token,
          VISBILITY_COUNT
        );
        setLocalStorage(SESSION_VALUE_FOR_LOGGED_IN, viewCounts + 1);
      }
      triggerWidgetEvent(TriggerWidgetType.IMPRESSION);
    }
  }, []);

  //clears the popup after the
  useEffect(() => {
    const timer = setTimeout(() => {
      setPopups({ showLanguageBanner: false });
    }, LAGNUAGE_BANNER_TIME_OUT);
    return () => clearTimeout(timer);
  }, []);

  return showPopup ? (
    <Container>
      <TextContainer>
        <Header>{headerText}</Header>
        <Title onClick={handleLanguagePopupClick}>{titleText}</Title>
      </TextContainer>
      <CrossButton onClick={handleClose} />
    </Container>
  ) : null;
};
export default LanguageToolTip;
